import React from 'react'
import PropTypes from 'prop-types'
import Card from '../../../../molecules/Card'
import StatusReportStatusIcon from '../../../../organisms/StatusReport/StatusReportStatusIcon'
import SydButton from '../../../../commonDesign/Button'
import Icon from '../../../../atoms/Icon'

function StatusIconCard ({
  status,
  onEdit
}) {
  return (
    <Card key={status.statusId}>
      <div className='flex gap-lg items-center'>
        <div>
          <StatusReportStatusIcon
            statusId={status.statusId}
            status={status}
            size={40}
            useIcon
            hasBackground
          />
        </div>

        <div className='flex-1 flex-col gap-md'>
          <div className='font-size-lg'>{status.displayName}</div>
          <div className='flex gap-md items-center'>
            <div className='flex gap-xs items-center'>
              <span className='font-size-xs text-secondary'>Code:</span>
              <code className='font-size-xs font-mono bg-neutral-100 px-xs rounded'>{status.codeName}</code>
            </div>
          </div>
          <div className='flex gap-sm items-center'>
            <span className='font-size-xs text-secondary'>Default icon:</span>
            <span
              className='font-size-xs flex items-center justify-center relative'
              style={{ width: '24px', height: '24px', color: status.color }}
            >
              <div className='absolute top-0 left-0 w-full h-full rounded opacity-lowlighted' style={{ backgroundColor: status.color }} />
              {status.icon?.length ? <Icon name={status.icon} size={18} /> : '-'}
            </span>
          </div>
        </div>

        <SydButton
          variant='primary'
          onClick={() => onEdit?.(status)}
          size='sm'
        >
          Manage
        </SydButton>
      </div>
    </Card>
  )
}

StatusIconCard.propTypes = {
  status: PropTypes.shape({
    codeName: PropTypes.string.isRequired,
    statusId: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    icon: PropTypes.string
  }).isRequired,
  onEdit: PropTypes.func
}

export default StatusIconCard
